import React from "react";
import { CTAButton } from "../CTAButton";
import { pains } from "../../data/landing";
export function Pains() {
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-200" data-mp="2danq678frnwe">
      <div className="mx-auto max-w-4xl" data-id="element-201" data-mp="2s6d6ppuur8tq">
        <h2 className="text-center font-display text-3xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-202" data-mp="2s7egzs41nrae">
          If you're a plastic surgeon or aesthetic physician, <em className="italic text-skydeep" data-id="element-203" data-mp="316t72qgatzud">you may recognize this…</em>
        </h2>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-204" data-mp="2w888swklxq8k">
          {pains.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-navy/5" data-id="element-205" data-mp="3axns5rht6te8">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-danger/10 text-danger" data-id="element-206" data-mp="35xro5s9431yo">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-207" data-mp="3jym18o73tr3o" />
              </span>
              <div data-id="element-208" data-mp="3fx8tg8kgbdu4">
                <h3 className="text-[17px] font-bold leading-snug text-navy" data-id="element-209" data-mp="3fxsbrqe0k48o">{title}</h3>
                <p className="mt-1.5 text-[15px] leading-relaxed text-ink/70" data-id="element-210" data-mp="j0yvevkf0qsn">{text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-211" data-mp="s0bvixmng30p">
          <p className="font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-212" data-mp="ryr25bc2mq4f">And it shouldn't have to feel so disorganized.</p>
          <p className="mt-4 text-[17px] leading-relaxed text-ink/80" data-id="element-213" data-mp="11yhvvast513g">
            Because the problem isn't necessarily a lack of knowledge. It's often a <strong className="text-navy" data-id="element-214" data-mp="15z1tefham6q4">lack of structured case practice.</strong> That's exactly why I created Liposuction Case Lab™ — something you could open before reviewing a case, work through, and use repeatedly to develop a more disciplined approach to case analysis.
          </p>
        </div>
        <div className="mt-10" data-id="element-215" data-mp="1kq2f3m71vx47">
          <CTAButton label="I want the case-based system" data-id="element-216" data-mp="1kmwmvy34kf49" />
        </div>
      </div>
    </section>;
}